<template>
  <div class="container-fluid">
    <div class="row mt-2">
      <div class="col-lg-12 bg-white border-radius-xl p-3">
        <step-progress
          :steps="mySteps"
          :current-step="currentStep"
          icon-class="fa fa-check"
          active-color="#1E1040"
          passive-color="#b6abd3"
          :active-thickness="3"
          :passive-thickness="3"
          :line-thickness="5"
          class="px-4"
        ></step-progress>
        <div class="row">
          <div class="" v-if="this.pagado==false">
            <div class="row justify-content-center">
              <div class="col-xl-12 col-lg-5 col-md-7 mx-auto">
                <div class="card z-index-0">
                  <div class="row card-body">
                    <div class="col-lg-6 col-md-12">
                      <h6 class="mt-1 text-addiuva">Datos del Programa</h6>
                      <hr class="horizontal dark" />
                      <detalle-programa
                        :programa = "programa"
                        :periodicidad = "periodicidad"
                        :inicio = "vigencia.inicio"
                        :fin = "vigencia.fin"
                        :tarifa = "tarifa"
                      ></detalle-programa>
                    </div>
                    <div class="col-lg-6 col-md-12">
                      <h6 class="text-addiuva">Datos de los Afiliados</h6>
                      <hr class="horizontal dark" />
                      <detalle-afiliados
                        :afiliados = "afiliados"
                      ></detalle-afiliados>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Compra Exitosa -->
          <div class="" v-if="this.pagado==false">
            <div class="row justify-content-center">
              <div class="col-xl-12 col-lg-5 col-md-7 mx-auto">
                <div class="card z-index-0">
                  <div class="row card-body">
                    <div class="mt-4 mb-4">
                      <div class="col-md-12 bg-gradient-success shadow text-center border-radius-md p-3">
                        <span class="text-white" style="user-select:none;">
                          <i class="fas fa-check-circle"></i> <span style="font-weight:600;">Compra Exitosa</span>
                        </span>
                      </div>
                    </div>
                    <ul style="padding:1rem 6rem;">
                      <li>
                        Si quieres dar de baja el servicio, recuerda que puedes hacerlo contactándote al <a class="text-addiuva" href="tel:77710774" style="font-weight:800;">800 xx xxx.</a>
                      </li>
                      <li>
                        Recuerda que en caso de necesitar Asistencia, el afiliado deberá comunicarse con nuestra Central de Atencion y proporcionar su nombre completo, número de documento de identidad, teléfono, ubicación y seguir las instrucciones que le imparta el Operador.
                      </li>
                      <li>
                        En caso de una emergencia el Afiliado deberá SIEMPRE obtener la autorización de la Central de Asistencia, antes de comprometer cualquier gasto en relaciona a los beneficios de su Programa. De lo contrario perderá el derecho de reembolso por cualquier gasto realizado unilateralmente.
                      </li>
                    </ul>
                    <documentos-generados
                      v-if="false"
                      :certificado = "certificado"
                      :afiliados = "afiliados"
                      :factura = "factura"
                    ></documentos-generados>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import Checkbox from 'primevue/checkbox';
import DetallePrograma from "./components/DetallePrograma.vue";
import DetalleAfiliados from "./components/DetalleAfiliados.vue";
import DocumentosGenerados from "./components/DocumentosGenerados.vue";
import StepProgress from 'vue-step-progress';
import 'vue-step-progress/dist/main.css';
// import Checkbox from 'primevue/checkbox';
import axios from 'axios';
import authHeader from '../services/auth-header';

export default {
  name: "Paso Generación Certificado",
  components: {
    // Checkbox,
    StepProgress,
    DetallePrograma,
    DetalleAfiliados,
    DocumentosGenerados
  },
  data() {
    return {
      mySteps: ['Seleccionar Programa', 'Registrar Afiliados', 'Finalizar Registro', 'Generación de Certificados'],
      currentStep:4,
      API_URL: process.env.VUE_APP_API_BASE_URL,
      code_afiliacion: this.$route.params.id,
      pagado: false,
      certificado: './certificado',
      factura: "/factura.url",
      programa: 'Vehicular',
      tarifa: 25.50,
      periodicidad: 'Mensual',
      afiliados: [
        {
          nombres: 'Jhon M',
          apellidos: 'Doe',
          dob: '1988-04-14',
          edad: '35',
          documento: '123456789LP',
          telefono: '59177789887',
          email: 'jjpere1@gmail.com',
        },
        {
          nombres: 'Mary A',
          apellidos: 'Smith',
          dob: '1988-04-14',
          edad: '35',
          documento: '123456789LP',
          telefono: '59177789887',
          email: 'jjpere1@gmail.com',
        },
      ],
      vigencia: {
        inicio: new Date().toJSON().slice(0, 10),
        fin: new Date().toJSON().slice(0, 10)
      },
      terminosCheck: false
    };
  },
  methods: {
    getAfiliationData(){
      let url = this.API_URL + "/afiliaciones/" + this.code_afiliacion;
      axios({
        url: url,
        method: 'get',
        headers: authHeader(),
      })
      .then(response => {
        if (response.data.status) {
          let info = response.data.data[0];
          this.pagado = false;
          this.certificado = './certificado';
          this.factura = "/factura.url";
          this.programa = info.nombre_programa;
          this.tarifa = info.tarifa;
          this.periodicidad = info.nombre_periodo;
          let aAfiliados = [];
          info.afiliados.forEach(afiliado => {
            aAfiliados.push({
              id_afiliado: afiliado.id_afiliado,
              codigo_certificado: afiliado.codigo_certificado,
              nombres: afiliado.nombres,
              apellidos: afiliado.apellidos,
              dob: afiliado.fecha_nacimiento,
              edad: afiliado.edad,
              documento: afiliado.numero_documento,
              telefono: afiliado.telefono,
              email: afiliado.email
            });
          });
          this.afiliados = aAfiliados;
          this.vigencia.inicio = info.fecha_inicio
          this.vigencia.fin = info.fecha_fin
        }
      })
      .catch(error => {
        console.log("Error: " + error);
      });
    },
    downloadPDF: function(id_afiliado) {
      // Send Data by Axios
      let url = this.API_URL + "/afiliaciones/certificado";
      axios({
        url: url,
        method: 'post',
        data: { "id_afiliado": id_afiliado },
        headers: authHeader(),
      })
      .then(response => {
        if (response.data.status) {
            let documento_certificado = response.data.data.documento_certificado;
            const linkSource = `data:application/pdf;base64,${documento_certificado}`;
            const downloadLink = document.createElement("a");
            const fileName = "abc.pdf";
            downloadLink.href = linkSource;
            downloadLink.download = fileName;
            downloadLink.click();
        }
      })
      .catch(error => {
        console.log("Error: " + error);
      });
    }
  },
  mounted() {
    this.getAfiliationData();
  }
};
</script>
<style scoped>
  #calendar-div {
    background-color: var(--bs-addiuva-purple) !important;
  }
  .vuejs3-datepicker__value{
    background-color: red !important;
  }
</style>